import React from 'react';
import Skeleton from 'react-loading-skeleton';

export const LoadingSkeletonTableRows = ({ rows, columns }: { rows: number; columns: number }) => (<>
    {Array.from(Array(rows).keys()).map(() => <tr>
        {Array.from(Array(columns).keys()).map(() => <td><Skeleton /></td>)}
    </tr>)}
</>);